import { AppEvents } from "./../../app-events";
import { Container } from "aurelia-dependency-injection";
import { IProductFilter } from "./../interfaces/product-filter";
import { AdvancedSearchFilterGroupModel } from "./advanced-search-filter-group";
import { AdvancedSearchFilterModel } from "./advanced-search-filter";
import { IAdvancedFormData } from "./../interfaces/advanced-form-data";
import { AdvancedSearchFieldModel } from "./advanced-search-field";
import { AdvancedSearchFormsCollection } from "./../collections/advanced-search-forms";
import { AuthorizationModel } from "./../../authentication/models/authorization-model";
import { AppSettings } from "./../../app-settings";
import { FiltersCollection } from "./../collections/filters";
import { FieldsCollection } from "./../collections/fields";
import { SearchModel } from "./search";
import { AdvancedSearchFormModel } from "./advanced-search-form";
import {prop} from "../../decorators/property";
import {backboneModelProperties} from "../../decorators/backbone-properties";
import { ContainerHelper } from "../../shared/helpers/container-helper";

@backboneModelProperties({
    url: `${AppSettings.SearchApiUrlPrefix}searchforms`,
    relations : [{
        type: Backbone.Many,
        key: "SearchForms",
        collectionType: AdvancedSearchFormsCollection,
        relatedModel: AdvancedSearchFormModel
    }],
    defaults: {
        SearchForms: [],
    }
})
export class AdvancedSearchModel extends AuthorizationModel {

    @prop() public SearchModel: SearchModel;
    @prop() public SearchForms: AdvancedSearchFormsCollection;
    @prop() public ActiveForm: AdvancedSearchFormModel;
    @prop() public InitialFormId = "all"; // We use this to set initial active form. Can set this variable before forms are loaded and it'll find the matching id.
    @prop() public InitialFormData: IAdvancedFormData;
    @prop() public Loaded = false;
    @prop() public AdvancedSearchEverOpened = false;
    private appEvents: Backbone.Events;

    constructor(options?) {
        super(options);
        this.appEvents = ContainerHelper.Events;
    }

    public get IncludedFiltersCount() {
        if (!this.ActiveForm) {
            return 0;
        }
        return this.ActiveForm.IncludedFiltersCount;
    }

    public get MaterialType() {
        if (!this.ActiveForm) {
            return "";
        }
        return this.ActiveForm.MaterialType;
    }

    public get AllProductFilters(): IProductFilter[] {
        if (!this.ActiveForm) {
            return [];
        }
        return this.ActiveForm.AllProductFilters;
    }

    public get CurrentFormID() {
        if (this.ActiveForm) {
            return this.ActiveForm.Identifier;
        } else {
            return this.InitialFormId;
        }
    }

    public areWeFilteringByProduct() {
        if (!this.ActiveForm) {
            return false;
        }

        return this.ActiveForm.areWeFilteringByProduct();
    }

    public clearFields() {
        if (!this.ActiveForm) {
            return;
        }
        this.ActiveForm.clearFields();
        this.trigger("KeyPressed");
    }

    public clearAllFormsFields() {
        this.SearchForms.forEach((form) => {
            form.clearFields();
        });
    }

    public clearAllFilters() {
        if (this.ActiveForm) {
            this.ActiveForm.clearAllFilters();
        }
    }

    public clearAllFormsFilters() {
        this.SearchForms.forEach((form) => {
            form.clearAllFilters();
        });
    }

    public getAdvancedFormData(): IAdvancedFormData {
        if (!this.ActiveForm) {
            return null;
        }
        return this.ActiveForm.getAdvancedFormData();
    }

    public selectForm(formID?: string) {
        if (!formID) {
            return;
        }
        if (!this.Loaded) {
            this.InitialFormId = formID;
            return;
        }

        let matchingForm = this.SearchForms.findWhere((f: AdvancedSearchFormModel) => f.Identifier === formID);
        if (!matchingForm) {
            matchingForm = this.SearchForms.first();
        }

        if (!this.ActiveForm) { // if there's no form state because we've never been here before, set the data on the form then make it active
            matchingForm.populateFields(this.InitialFormData);
            this.InitialFormData = null; // clear this after using
            this.ActiveForm = matchingForm;
            this.ActiveForm.AdvancedSearchEverOpened = false;
        } else { // if there is form state select the form first, which will write its state back to the SearchTree on the search model.
            this.ActiveForm = matchingForm;
            matchingForm.populateFields(this.InitialFormData);
            this.InitialFormData = null;
            this.ActiveForm.AdvancedSearchEverOpened = true;
        }
    }

    public populateFields(data: IAdvancedFormData) {
        if (!this.ActiveForm) {
            this.InitialFormData = data;
        } else {
            this.ActiveForm.populateFields(data);
        }
    }

    public load(formID: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.fetch({
                // beforeSend: AppUser.attachAuthorizationHeader,
                success: () => {
                    this.selectForm(formID);
                    this.SearchForms.each((form: AdvancedSearchFormModel) => {
                        form.SearchFields.each((field: AdvancedSearchFieldModel) => {
                            field.AdvancedSearch = this;
                            field.SearchForm = form.Identifier;
                        });
                        form.SearchFilterGroups.each((filterGroup: AdvancedSearchFilterGroupModel) => {
                           filterGroup.Filters.each((filter: AdvancedSearchFilterModel) => {
                                filter.AdvancedSearch = this;
                                filter.Enabled = true;
                           });
                        });
                    });
                    this.Loaded = true;
                    this.appEvents.trigger(AppEvents.AdvancedSearchFormsLoaded, this);
                    resolve();
                },

                error: (e) => {
                    // todo
                }
            });
        });
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/advanced-search.ts